<template>
    <form
        ref="formRef"
        :action="url"
        :method="method"
        class="configurator mt-6"
        @submit="onSubmit"
    >
        <div class="rounded-sm bg-gray-700 py-6 text-white">
            <slot />
        </div>
    </form>
</template>

<script setup>
defineOptions({ name: 'FeConfiguratorRoot' });
import { ref } from 'vue';

const props = defineProps({
    url: {
        type: String,
        required: true,
    },
    method: {
        type: String,
        default: 'GET',
    },
    beforeSubmit: {
        type: Function,
        default: () => {},
    },
});

const formRef = ref(null);

const onSubmit = (event) => {
    event.preventDefault();

    props.beforeSubmit();

    formRef.value?.submit();
};
</script>
